import { ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { createTheme } from '@liscio/ui';

import { useFirmViewMode } from 'custom-hooks/useFirmViewMode';
import { desktopComponents } from 'theme/desktopComponents';
import { documentPreview } from 'theme/documentPreview';
import { refactorComponents } from 'theme/refactor-theme';
import { typography } from 'theme/typography';

/**
 * ConditionalThemeProvider
 */
export const ConditionalThemeProvider: React.FC = () => {
  const { isDesktop } = useFirmViewMode();
  const theme = createTheme({
    extensions: [
      typography,
      desktopComponents,
      refactorComponents,
      documentPreview,
    ],
  });

  if (isDesktop) {
    return (
      <ThemeProvider theme={theme}>
        <Outlet />
      </ThemeProvider>
    );
  }
  return <Outlet />;
};
